// extracted by mini-css-extract-plugin
export default {"toast":"SessionExpiredToast_toast__MLNVl","message":"SessionExpiredToast_message__qkhBo"};